// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectNavButton_wrapper__1m+xI","button":"ProjectNavButton_button__0m2GM","icon":"ProjectNavButton_icon__oa3dS","label":"ProjectNavButton_label__JYvA4"};